import {
  getCLS, getFID, getFCP, getLCP, Metric,
} from 'web-vitals';
import { triggerCustomEvent } from 'lib/helpers';

const collectWebVitals = (data:Metric) => {
  triggerCustomEvent('snowplow:web_vitals_report', data);
};

window.addEventListener('DOMContentLoaded', () => {
  getFCP(collectWebVitals);
  getCLS(collectWebVitals, true);
  getFID(collectWebVitals);
  getLCP(collectWebVitals);
});
